import React, { useEffect, useRef } from "react";
import { ZaunCircleMenuItem } from "./ZaunCircleMenuItem";
import { SizeNumber } from "../SizeNumber";
import { getWorldAxesFromCameraDirection } from "../../commons/Utils";

const selectedAufbauten = () => APP.arrangement.selectedObjects.filter((a) => a.isAufbau);

export function ZaunCircleMenuItemAufbautenSize() {
  const agt = APP.arrangement;

  const selected = agt.selectedObjects[0];

  const contract = () => {
    return selected?.isAufbau;
  };

  if (!contract()) {
    return null;
  }

  const minMaxBox = selected.getMassMinMaxBox3();

  const DimEingabe = (axis: "x" | "y" | "z") => {
    return (
      <SizeNumber
        key={selected.id + "." + axis}
        dataInputKey={"size." + axis}
        value={selected.size[axis]}
        setter={(value) => selectedAufbauten().forEach((a) => (a.size[axis] = value))}
        min={minMaxBox.min[axis]}
        max={minMaxBox.max[axis]}
        disabled={false}
      />
    );
  };

  return (
    <ZaunCircleMenuItem
      className={"onTop"}
      onClick={(event) => {
        event.stopPropagation();
        const input = (event.target as HTMLElement).querySelector("input");
        input && input.focus();
      }}
    >
      <div className="flex-column">
        <div className="flex-row align-items-center">
          {I18N("Breite")} {DimEingabe("x")}
          &nbsp;&nbsp; x &nbsp;&nbsp;
          {I18N("Tiefe")} {DimEingabe("z")}
        </div>
      </div>
    </ZaunCircleMenuItem>
  );
}

const setForbidUpdate = (forbidUpdate) => {
  if (APP.zaunCircleMenu) {
    APP.zaunCircleMenu.forbidUpdate = forbidUpdate;
    if (!forbidUpdate) {
      APP.zaunCircleMenu.update();
    }
  }
};

export function ZaunCircleMenuItemAufbautenPos() {
  const agt = APP.arrangement;

  const selected = agt.selectedObjects[0];

  const contract = () => {
    return selected?.isAufbau;
  };

  if (!contract()) {
    return null;
  }

  return (
    <ZaunCircleMenuItem className={"onTop"}>
      <div className="flex-column">
        <div className="flex-row">
          <div
            className="direction-cross"
            role="group"
            aria-label={I18N("aria::Richtungssteuerung")}
            onMouseEnter={() => setForbidUpdate(true)}
            onMouseLeave={() => setForbidUpdate(false)}
          >
            <div className="empty"></div>
            <PosButton className="button outlined-button up" label={"△"} direction="zp" />
            <PosButton className="button outlined-button left" label={"◁"} direction="xn" />
            <PosButton className="button outlined-button right" label={"▷"} direction="xp" />
            <PosButton className="button outlined-button down" label={"▽"} direction="zn" />
          </div>
        </div>
      </div>
    </ZaunCircleMenuItem>
  );
}

function PosButton({
  label,
  direction,
  className,
}: {
  label: string;
  direction: string;
  className: string;
}) {
  const update = () => {
    const dir = getWorldAxesFromCameraDirection()[direction].clone().multiplyScalar(0.01);
    selectedAufbauten().forEach((a) => {
      a.position.add(dir);
      a.jaco3d.update3d();
      STAGE.dirty();
    });
  };

  const timer = useRef<ReturnType<typeof setInterval> | null>(null);
  const initialDelayTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const clear = () => {
    clearInterval(timer.current);
    clearTimeout(initialDelayTimer.current);
    APP.insideAnimationBlockUpdate3d = false;
    APP.update3d();
    APP.trigger("changedConfiguration");
  };

  // Stellt sicher, dass die Timer gestoppt werden, wenn die Komponente unmountet
  useEffect(() => {
    clear();
    APP.dirty();
  }, []);

  return (
    <button
      className={className}
      data-input-key={label}
      onMouseDown={() => {
        APP.insideAnimationBlockUpdate3d = true;
        update();
        initialDelayTimer.current = setTimeout(() => {
          timer.current = setInterval(update, 10);
        }, 200);
      }}
      onMouseUp={clear}
      onMouseLeave={clear}
    >
      {label}
    </button>
  );
}
